import { api } from './api'
import { apiErrorMessage } from './apiError'

// NOT: api.* artık ApiError fırlatıyor ve ApiError'da `.response` YOK. Buradaki eski
// `error.response?.data?.message` okumaları her zaman undefined dönüyor, backend'in
// TR mesajı jenerik metinle eziliyordu. toApiError(error).message her zaman
// gösterilebilir bir metin tutar (önce backend mesajı, yoksa hata türüne göre TR metin).

export interface Company {
  id: number
  name: string
  contact_email?: string
  authorized_number?: string
  address?: string
  phone?: string
  bucket_name?: string
  is_active: boolean
  created_at: string
}

export interface AddCompanyData {
  name: string
  contact_email?: string
  authorized_number?: string
  phone?: string
  address?: string
}

interface CompanyResponse {
  success: boolean
  data?: Company[]
  message?: string
}

interface SingleCompanyResponse {
  success: boolean
  data?: Company
  message?: string
}

export const companyService = {
  async getCompanies(): Promise<CompanyResponse> {
    try {
      const response = await api.get('/companies')
      
      if (response.success && Array.isArray(response.data)) {
        return {
          success: true,
          data: response.data,
          message: response.message
        }
      }
      
      return {
        success: false,
        message: response.message || 'Şirketler yüklenemedi'
      }
    } catch (error) {
      return {
        success: false,
        message: apiErrorMessage(error, 'Şirketler alınırken hata oluştu')
      }
    }
  },

  async addCompany(companyData: AddCompanyData): Promise<SingleCompanyResponse> {
    
    try {
      const response = await api.post('/companies', companyData)
      
      if (response.success && response.data) {
        return {
          success: true,
          data: response.data as Company,
          message: response.message
        }
      }
      
      return {
        success: false,
        message: response.message || 'Şirket eklenemedi'
      }
    } catch (error) {
      return {
        success: false,
        message: apiErrorMessage(error, 'Şirket eklenirken hata oluştu')
      }
    }
  },

  async updateCompany(id: number, companyData: AddCompanyData): Promise<SingleCompanyResponse> {
    
    try {
      const response = await api.put(`/companies/${id}`, companyData)
      
      if (response.success && response.data) {
        return {
          success: true,
          data: response.data as Company,
          message: response.message
        }
      }
      
      return {
        success: false,
        message: response.message || 'Şirket güncellenemedi'
      }
    } catch (error) {
      return {
        success: false,
        message: apiErrorMessage(error, 'Şirket güncellenirken hata oluştu')
      }
    }
  },

  async deleteCompany(id: number): Promise<SingleCompanyResponse> {
    
    try {
      const response = await api.delete(`/companies/${id}`)
      
      if (response.success) {
        return {
          success: true,
          data: response.data as Company,
          message: response.message
        }
      }
      
      return {
        success: false,
        message: response.message || 'Şirket silinemedi'
      }
    } catch (error) {
      return {
        success: false,
        message: apiErrorMessage(error, 'Şirket silinirken hata oluştu')
      }
    }
  }
} 